var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "filter-header d-flex justify-content-end" },
        [
          _c(
            "button",
            {
              staticClass: "btn btn-purple align-self-start",
              on: { click: _vm.togglePanel },
            },
            [_c("i", { staticClass: "fas fa-filter" })]
          ),
          _vm._v(" "),
          _vm._t("buttons"),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "d-flex" },
        [
          _c("applied-filters", {
            attrs: { items: _vm.appliedLabels },
            on: { "filter-remove": _vm.onFilterRemove },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("el-collapse-transition", [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isPanelVisible,
                expression: "isPanelVisible",
              },
            ],
          },
          [
            _c(
              "div",
              { staticClass: "row mt-2" },
              _vm._l(_vm.list, function (item) {
                return _c(item.component, {
                  key: item.name,
                  tag: "component",
                  class: item.classes,
                  attrs: {
                    name: item.name,
                    values: _vm.values,
                    "pending-values": _vm.pending,
                    data: item.data,
                  },
                  on: {
                    change: _vm.onChange,
                    "labels-changed": _vm.onLabelsChanged,
                  },
                })
              }),
              1
            ),
            _vm._v(" "),
            _c(
              "button",
              { staticClass: "btn btn-default", on: { click: _vm.apply } },
              [_vm._v("Apply")]
            ),
            _vm._v(" "),
            _c(
              "button",
              { staticClass: "btn btn-default", on: { click: _vm.hide } },
              [_vm._v("Hide")]
            ),
            _vm._v(" "),
            _c(
              "button",
              { staticClass: "btn btn-default", on: { click: _vm.reset } },
              [_vm._v("Reset")]
            ),
          ]
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }